import { IconCheckupList, IconLink } from '@tabler/icons-react';
import React from 'react';
import PropTypes from 'prop-types';

function Deductibles({ data }) {
  const plans = [
    { key: 'standard_plan', label: 'Standard Plan' },
    { key: 'cost_sharing_reduction_plans.73_percent', label: '73% Plan' },
    { key: 'cost_sharing_reduction_plans.87_percent', label: '87% Plan' },
    { key: 'cost_sharing_reduction_plans.94_percent', label: '94% Plan' },
  ];

  const getPlanData = (path) => {
    return path.split('.').reduce((obj, key) => obj?.[key] ?? {}, data);
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#flush-collapse-deductibles`}
          aria-expanded="false"
          aria-controls={`flush-collapse-deductibles`}
        >
          <IconLink size={18} className="me-2 my-2" />
          Deductibles and Maximum Out of Pocket (OOP)
        </button>
      </h2>
      <div
        id={`flush-collapse-deductibles`}
        className="accordion-collapse collapse"
      >
        <div className="accordion-body">
          {plans.map((plan, index) => {
            const planData = getPlanData(plan.key);
            const isStandardPlan = plan.key === 'standard_plan';

            return (
              <div
                className="ps-table table-responsive mb-4"
                key={`deductible-plan-${index}`}
              >
                <h4>
                  <IconCheckupList size={20} className="me-2 text-muted" />{' '}
                  {plan.label}
                </h4>
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col" className="col-1">
                        Type
                      </th>
                      <th scope="col" className="col-1">
                        Individual
                      </th>
                      <th scope="col" className="col-1">
                        Family
                      </th>
                      <th scope="col" className="col-1">
                        Family Per Person
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Medical Deductible */}
                    <tr>
                      <td>Medical Deductible</td>
                      <td>
                        {planData?.medical_deductible?.individual || 'N/A'}
                      </td>
                      <td>{planData?.medical_deductible?.family || 'N/A'}</td>
                      <td>
                        {planData?.medical_deductible?.family_per_person ||
                          'N/A'}
                      </td>
                    </tr>

                    {/* Drug Deductible (Only for Standard Plan) */}
                    {isStandardPlan && (
                      <tr>
                        <td>Drug Deductible</td>
                        <td>
                          {planData?.drug_deductible?.individual || 'N/A'}
                        </td>
                        <td>{planData?.drug_deductible?.family || 'N/A'}</td>
                        <td>
                          {planData?.drug_deductible?.family_per_person ||
                            'N/A'}
                        </td>
                      </tr>
                    )}

                    {/* Medical Max OOP */}
                    <tr>
                      <td>Medical Max OOP</td>
                      <td>
                        {planData?.medical_maximum_out_of_pocket?.individual ||
                          'N/A'}
                      </td>
                      <td>
                        {planData?.medical_maximum_out_of_pocket?.family ||
                          'N/A'}
                      </td>
                      <td>
                        {planData?.medical_maximum_out_of_pocket
                          ?.family_per_person || 'N/A'}
                      </td>
                    </tr>

                    {/* Drug Max OOP (Only for Standard Plan) */}
                    {isStandardPlan && (
                      <tr>
                        <td>Drug Max OOP</td>
                        <td>
                          {planData?.drug_maximum_out_of_pocket?.individual ||
                            'N/A'}
                        </td>
                        <td>
                          {planData?.drug_maximum_out_of_pocket?.family ||
                            'N/A'}
                        </td>
                        <td>
                          {planData?.drug_maximum_out_of_pocket
                            ?.family_per_person || 'N/A'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
Deductibles.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Deductibles;
